import { APP_INITIALIZER } from '@angular/core';
import {
    SentryConfig,
    initSentry,
} from '@de-care/shared/configuration-tokens-sentry';

export function provideSentry({
    sentryConfig,
}: {
    sentryConfig: SentryConfig;
}) {
    return [
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                return () => {
                    initSentry(sentryConfig);
                };
            },
            multi: true,
        },
    ];
}
